import Sidebar from './SideBar.vue'

const SidebarStore = {
  showSidebar: false,
  sidebarLinks: [
    {
      name: 'Szacunkowe wpłaty 1%',
      icon: 'ti-panel',
      path: '/panel/wplaty',
      child: true
    },
    {
      name: 'Uruchomienia i Wypełnienia',
      icon: 'ti-panel',
      path: '/panel/uruchomienia-wypelnienia',
      child: true
    },
    {
      name: 'Statystyki pobrań',
      icon: 'ti-view-list-alt',
      path: '/panel/statystyki-pobran',
      child: false
    },
    {
      name: 'Statystyki deklaracji',
      icon: 'ti-view-list-alt',
      path: '/panel/statystyki-deklaracji',
      child: false
    }
    // {
    //   name: 'Profil',
    //   icon: 'ti-user',
    //   path: '/panel/stats'
    // }
  ],
  displaySidebar (value) {
    this.showSidebar = value
  }
}

const SidebarPlugin = {

  install (Vue) {
    Vue.mixin({
      data () {
        return {
          sidebarStore: SidebarStore
        }
      }
    })

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get () {
        return this.$root.sidebarStore
      }
    })
    Vue.component('side-bar', Sidebar)
  }
}

export default SidebarPlugin



// WEBPACK FOOTER //
// ./src/components/UIComponents/SidebarPlugin/index.js